module.exports = __webpack_public_path__ + "static/media/dominos.cb646c61.jpg";